export const FORM_STATUS_UNSUBMITTED = 1;
export const FORM_STATUS_AWAITING_PAYMENT_RESPONSE = 2;
export const FORM_STATUS_3DS_CHALLENGE_ACTIVATED = 3;
export const FORM_STATUS_API_BOOKING_PROCESSING = 4;
